import React from "react";
import { useTranslation } from "react-i18next";
import { QrAPI } from "../../../services/api";
import { ReactComponent as RefreshIcon } from "../../../assets/icons/dashboard/refresh.svg";
import { ReactComponent as DownloadIcon } from "../../../assets/icons/listallbuilding/download.svg";
import { ReactComponent as DeleteIcon } from "../../../assets/icons/setqr/delete.svg";

/**
 * Popup แสดง QR image + ปุ่ม download/ลบ
 * (ตามรูปที่ 3)
 */
export default function QrViewModal({ qr, onClose, onDeleted }) {
  const { t } = useTranslation();

  const onDownload = () => {
    // เปิด download URL ในแท็บใหม่ — backend ต้อง response เป็น attachment
    const a = document.createElement("a");
    a.href = QrAPI.downloadUrl(qr.id, qr.code);
    a.download = `${qr.code || "qr"}.png`;
    a.target = "_blank";
    a.rel = "noopener";
    a.click();
  };

  const onDelete = async () => {
    if (!window.confirm(t("admin.qrViewModal.confirmDelete", { code: qr.code }))) return;
    try {
      await QrAPI.remove(qr.id);
      onDeleted?.();
    } catch (e) {
      alert(e.message || t("admin.qrViewModal.deleteFailed"));
    }
  };

  return (
    <div
      className="fixed inset-0 z-50 bg-black/70 flex items-center justify-center p-4"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-lg w-full max-w-[360px] p-6 relative"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          onClick={onClose}
          className="absolute right-4 top-4 text-slate-400 hover:text-slate-600 text-xl"
        >
          ×
        </button>

        {/* QR Big */}
        <div className="flex justify-center my-2">
          <div className="border-y-4 border-yellow-500 py-3 px-6">
            <img
              src={QrAPI.imageUrl(qr.id, 512, qr.code)}
              alt={qr.code}
              className="w-36 h-36"
            />
          </div>
        </div>

        <div className="flex items-center justify-between mt-3">
          <div className="font-semibold text-base mt-2 text-slate-700">{t("admin.qrViewModal.autoGenerated")}</div>
          <div className="font-base text-sm mt-2 text-blue-700 inline-flex items-center gap-1.5">
            <RefreshIcon className="w-3 h-3 text-blue-700" />
            {t("admin.qrViewModal.newGenerated")}
          </div>
          {/* placeholder ปุ่มสร้างใหม่ — backend ต้อง support regenerate ถ้าจะใช้ */}
        </div>

        {/* รายละเอียด card */}
        <div className="mt-3 bg-green-50/60 border border-green-600 rounded-lg p-6 flex items-center gap-3">
          <div className="flex-1 min-w-0">
            <div className="text-xs text-green-700 ">{t("admin.qrViewModal.details")}</div>
            <div className="text-sm mt-2 text-black truncate">
              {qr.name} {qr.floorName ? `- ${qr.floorName}` : ""}
            </div>
          </div>
          <img
            src={QrAPI.imageUrl(qr.id, 80, qr.code)}
            alt=""
            className="w-10 h-10 border border-black bg-white p-1 rounded"
          />
        </div>

        <button
          onClick={onDownload}
          className="mt-4 w-full h-11 rounded-xl bg-blue-600 hover:bg-blue-700 text-white font-semibold flex items-center justify-center gap-2"
        >
          <DownloadIcon className="w-4 h-4 text-white" />
          {t("admin.qrViewModal.downloadQr")}
        </button>

        <button
          onClick={onDelete}
          className="mt-2 w-full h-11 rounded-xl bg-red-50 hover:bg-red-100 text-red-600 border border-red-100 font-semibold flex items-center justify-center gap-2"
        >
          <DeleteIcon className="w-4 h-4 text-red-600" />
          {t("admin.qrViewModal.deleteQr")}
        </button>
      </div>
    </div>
  );
}
